// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"fe5b268f","544":"024030b3"}[chunkId] + ".chunk.js";
};